import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LanguageService} from '../../../services/language.service';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-language-view',
  templateUrl: './language-view.component.html',
  styleUrls: ['./language-view.component.scss']
})
export class LanguageViewComponent implements OnInit {

  language = {};
  constructor(private graphqlService: LanguageService,
              private utilsService: UtilsService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.graphqlService.findOne(id).subscribe(result => {
      if (result && result.data) {
        this.language = JSON.parse(JSON.stringify(result.data['language']));
        this.utilsService.openSnackBar('Language Loaded !!', '');
      }
    });
  }

  update() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.language['name'], this.language['slug']);
    if (requiredSuccess) {
      this.graphqlService.update(this.language).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Language Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update language.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  delete() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.language).subscribe(({data}) => {
      this.utilsService.openSnackBar('Language Deleted !!', '');
      this.router.navigate(['/languages']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete language.', '');
      console.log('there was an error sending the query', error);
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/languages/language-view/language-view.component.ts